


import React, {
  PropTypes,
  Component
} from 'react';
import './index.less';

import mobx from 'mobx';

import { Switch } from 'antd-mobile';
import Icon from '../Icon';

export default class CheckButton extends Component {
  state = {}

  constructor(props) {
    super(props);
    this.state.checked = this.parseValue(props.value);
  }

  parseValue(value) {
    if (typeof value == 'string') {
      return value == 'true' || value == 'True' || value == '1';
    } else {
      return !!value;
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      checked: this.parseValue(nextProps.value)
    });
  }

  handleChange = (e) => {
    // e.preventDefault();
    this.setState({
      checked: e
    });
    if (this.props.onChange) {
      // this.props.onChange(!this.state.checked);
      this.props.onChange({value:e, text:e.toString()});
    }
  }

  render() {
    const {
      name
    } = this.props;
    return (
      <div className='check-switch-button'>
        {/* <Icon type={this.state.checked?'fuxuan':'weixuan'} className='checkicon'/> */}
        <span>{name}</span>
        <Switch name='11' checked={this.state.checked} color='#4dd865' onChange={this.handleChange} />
      </div>
    )
  }

}

